import { useTranslation } from '@mint-lib/i18n';
import { Add } from '@mint-lib/icons';
import { Illustration } from '@mint-lib/illustrations';
import { useIsAllowedPermission } from '@mint-lib/profile-helpers';
import { Button, typographyVariants } from '@mint-lib/tw-components';
import { getRouteApi } from '@mint/routing';

const routeApi = getRouteApi('/_secured/company-profile/flows/');

const EmptyPage = () => {
  const { t } = useTranslation('@myn/approval_v2');
  const navigate = routeApi.useNavigate();
  const isReadOnly = !useIsAllowedPermission('approvalFlowFeature:modify');

  const handleCreateFlow = () => {
    navigate({
      to: '/company-profile/flows/new-flow',
    });
  };

  return (
    <div className="flex h-full flex-col items-center justify-center text-center">
      <div className="grid place-items-center gap-4">
        <Illustration className="size-40" component="IllustrationEmptyState" />
        <div className="grid gap-2">
          <h4 className={typographyVariants({ variant: 'h4' })}>
            {t('No flow yet')}
          </h4>
          <p
            className={typographyVariants({
              variant: 'bodyShort01',
              color: 'secondary',
            })}
          >
            {t('Get started with your first approval flow creation.')}
          </p>
        </div>
        <Button
          aria-label="Create a flow"
          data-dd-action-name="Create new flow"
          size="large"
          variant="contained"
          color="primary"
          onClick={handleCreateFlow}
          disabled={isReadOnly}
        >
          <Add className="shrink-0" />
          {t('New flow')}
        </Button>
      </div>
    </div>
  );
};

export default EmptyPage;
